import React, { useEffect, useContext, useState } from 'react'
import SunEditor from 'suneditor-react'
import { LanguageContext } from '../Language/LanguageContext'
import { updateContent, getContent } from '../Network/Content'
import { NotifyContext } from '../Library/Notify'
import 'suneditor/dist/css/suneditor.min.css'
import { Button } from 'react-bootstrap'
import { Container, Loading, HeaderTitle } from '../Library'
import { setDocumentTitle } from '../AppTitle'
import "./TermsandPolicies.css"

function TermsandPolicies() {
    const [isLoading, setLoading] = useState(false)
    const notify = useContext(NotifyContext)
    const contentId = 1
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.content
    const [originalContent, setOriginalContent] = useState("")
    const [content, setContent] = useState("");

    useEffect(()=>{
        //setDocumentTitle("Term and Policy")
        setLoading(true)
        getContent(contentId, 
            (data)=>{
                setContent(data.content)
                setOriginalContent(data.content)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })

        function closeListener(e){
            e.preventDefault()
            e.returnValue = lang.changed_alert
            return lang.changed_alert
        }
    
        window.addEventListener("beforeunload", closeListener)
    
        return () =>{
            window.removeEventListener("beforeunload", closeListener)
        }
    },[])

    const updateTerm = () =>{
        setLoading(true)
        updateContent(contentId, content,
            (data)=>{
                notify.showNotify(lang.term_success, lang.term_success_desc, 0)
                setOriginalContent(data.content)
                setLoading(false)
            },
            (error)=>{
                console.log(error.response)
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }
   
    return (
        <div>
        { isLoading ? <Loading/> : null }
        <div id="terms_and_policiesd">
            <HeaderTitle 
            title={lang.edit_term}
            customRight={
                <>
                { originalContent !== content ?
                <div className="content-change">
                    <div className="indicator"></div>
                    <span>{lang.content_change}</span>
                </div>
                : null
                }
                </>
            }/>
            <div className ="editor">
                <SunEditor width="100%" height="600" setOptions={{
                    buttonList: [
                        ['undo', 'redo'],
                        ['font', 'fontSize', 'formatBlock'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link'],
                        ['fullScreen', 'showBlocks'],
                    ]
			    }}
                setContents={content}
                onChange={setContent}
                />
            </div>
            <hr/>
            <Button className="edit-btn" 
            onClick={()=>updateTerm()}>
                {lang.save_change}
            </Button>
        </div>
        </div>
    )
}

export default TermsandPolicies